import type { Mode } from "../../../components/general/types/Modify";
import { api } from "../../../services/jobpermissions.service";
import { useJobPermission } from "./useJobPermission";

const permission = "EditNotes";

export const useCanEditNotes = (mode: Mode, fetch: boolean) =>
  useJobPermission(mode, fetch, api.editNotes, permission);
